import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "matching-list__cards"
}
const _hoisted_2 = { class: "matching-list__cards-header" }
const _hoisted_3 = { class: "matching-list__cards-headline" }
const _hoisted_4 = { class: "matching-results-loading--info" }
const _hoisted_5 = {
  key: 0,
  class: "matching-list__cards-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterBar = _resolveComponent("FilterBar")!
  const _component_MatchingCardPlaceholder = _resolveComponent("MatchingCardPlaceholder")!
  const _component_MatchingResultsLoading = _resolveComponent("MatchingResultsLoading")!
  const _component_MatchingCardCompact = _resolveComponent("MatchingCardCompact")!
  const _component_MatchingCardCompactPlaceholder = _resolveComponent("MatchingCardCompactPlaceholder")!
  const _component_VirtualGrid = _resolveComponent("VirtualGrid")!
  const _component_MatchingEmptyResults = _resolveComponent("MatchingEmptyResults")!

  return true
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t(
            `matching.matchingList.discoverInterest[${_ctx.$user.getUserAccountType()}]`,
          )) + " (" + _toDisplayString(_ctx.$store.state.matchingSearch.hit_count) + ") ", 1),
          _createVNode(_component_FilterBar)
        ], 512), [
          [_vShow, _ctx.hasFilters || _ctx.hasDiscoverCards]
        ]),
        (_ctx.isLoadingNewMatches || (_ctx.isLoadingInitialMatches && !_ctx.hasFilters))
          ? (_openBlock(), _createBlock(_component_MatchingResultsLoading, { key: 0 }, _createSlots({
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expandedMatchesQuantity, (index) => {
                  return (_openBlock(), _createBlock(_component_MatchingCardPlaceholder, {
                    key: `virtual-list-placeholder-${index}`
                  }))
                }), 128))
              ]),
              _: 2
            }, [
              (_ctx.isCalculatingInitialResults)
                ? {
                    name: "action",
                    fn: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.$t(`matching.matchingList.loadingResultsState.title`)), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t(`matching.matchingList.loadingResultsState.subtitle`)), 1)
                      ])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1024))
          : (_ctx.hasDiscoverCards)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.hasCompactMatches)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_VirtualGrid, {
                        columns: _ctx.virtualGridColumns,
                        "grid-gap": _ctx.virtualGridGap,
                        "item-height": _ctx.virtualRowHeight,
                        "load-on-mount": true,
                        items: _ctx.results,
                        onScroll: _ctx.fetchMoreMatches
                      }, {
                        items: _withCtx((items) => [
                          (_ctx.showListFeature)
                            ? (_openBlock(), _createBlock(_component_MatchingCardCompact, {
                                key: `compact-card-${items.item.index}`,
                                about: items.item.about,
                                badges: items.item.badges,
                                "company-id": Number(items.item.company_id),
                                "company-uid": items.item.uid,
                                disabled: items.item.disabled,
                                "is-directory-member": items.item.isDirectoryMember,
                                level: items.item.vil,
                                location: _ctx.getLocationDisplay(items.item),
                                locations: items.item.locations,
                                "match-percentage": items.item.percentage,
                                name: items.item.name,
                                offerings: items.item.offerings,
                                sectors: items.item.sectors,
                                thumbnail: items.item.logo,
                                onClick: ($event: any) => (_ctx.clickMatchingCardHandler(items.item.company_id))
                              }, null, 8, ["about", "badges", "company-id", "company-uid", "disabled", "is-directory-member", "level", "location", "locations", "match-percentage", "name", "offerings", "sectors", "thumbnail", "onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        loading: _withCtx((loading) => [
                          (_openBlock(), _createBlock(_component_MatchingCardCompactPlaceholder, {
                            key: `virtual-list-placeholder-${loading.item}`
                          }))
                        ]),
                        _: 1
                      }, 8, ["columns", "grid-gap", "item-height", "items", "onScroll"])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.hasNoCurrentMatches)
              ? (_openBlock(), _createBlock(_component_MatchingEmptyResults, {
                  key: 2,
                  notice: !_ctx.hasFilters,
                  "notice-button": _ctx.emptyNoticeButton,
                  "notice-subtitle": _ctx.emptyNoticeSubtitle,
                  "notice-title": _ctx.emptyNoticeTitle,
                  subtitle: _ctx.emptySubtitle,
                  title: _ctx.emptyTitle,
                  icon: "matching.matchingList.emptyState.icon"
                }, null, 8, ["notice", "notice-button", "notice-subtitle", "notice-title", "subtitle", "title"]))
              : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}